import { AsyncRsModal } from '@/chart/components/async-rs-modal';
import { memo, useCallback, useState } from 'react';
import { EstimatedRentalActivitiesCalendar } from './details-calendar';
import { PropertyDetailsCharts } from './details-charts';
import { NoDatapointsPlaceholder } from './no-datapoints-placeholder';

/**
 * Visualizations for property details
 *
 * @params {Boolean} centered determines if component allow rsuite's Grid default styles to auto
 *  center its contents
 */
function DetailsVisComponent({ propertyData }) {
  const [currActiveModal, setCurrActiveModal] = useState(null);

  const hideChartCB = useCallback(() => {
    setCurrActiveModal(null);
  }, [setCurrActiveModal]);

  if (!propertyData?.dataPoints) return <NoDatapointsPlaceholder />;

  return (
    <div data-testid="property-details-overview-details-visualizations">
      <EstimatedRentalActivitiesCalendar propertyData={propertyData} />

      <PropertyDetailsCharts
        propertyData={propertyData}
        setCurrActiveModal={setCurrActiveModal}
      />

      <AsyncRsModal
        chartType={currActiveModal}
        onHide={hideChartCB}
        propertyData={propertyData}
      />
    </div>
  );
}

export const DetailsVis = memo(DetailsVisComponent);
